import Component from '../inherited/Component'

export default class CartUpsells extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._select = this._elem.querySelector('.upsells-add-select')
  }

  mount () {
    this._select.addEventListener('change', (event) => {
      const upsellData = JSON.parse(this._elem.querySelector('[data-upsell-json]').innerHTML)
      const colorSelected = event.target.getAttribute('data-color-variant').toLowerCase();
      const sizeSelected = event.target.value.toLowerCase();
      console.log(event.target)
      const variantInput = this._elem.querySelector('.variant-id');
      const addBtn = this._elem.querySelector('.upsell_add');
      const variantId = upsellData.variants.find(variant => variant.color === colorSelected && variant.size === sizeSelected).id

      variantInput.value = variantId;
      addBtn.click();
    })
  }
}